<template>
  <!-- Show all (mobile and desktop) -->
  <RevButton
    v-if="isCollapsible && !isExpanded && hiddenProducts.length > 0"
    :aria-controls="`${LIST_ID_DESKTOP} ${LIST_ID_MOBILE}`"
    :aria-expanded="isExpanded"
    class="mt-16 md:mt-12 w-full md:w-auto"
    size="small"
    type="button"
    variant="secondary"
    @click="toggleExpanded"
  >
    {{ i18n(translations.showAll) }}
  </RevButton>

  <!-- Desktop Show less -->
  <RevButton
    v-if="isCollapsible && isExpanded"
    :aria-controls="LIST_ID_DESKTOP"
    :aria-expanded="isExpanded"
    class="hidden md:block mt-12"
    size="small"
    type="button"
    variant="secondary"
    @click="toggleExpanded"
  >
    {{ i18n(translations.showLess) }}
  </RevButton>

  <!-- Divider (mobile and desktop) -->
  <RevDivider
    v-if="seeOtherUrl && isCollapsible && isExpanded"
    class="my-12"
    :class="{ hidden: !isValidSeeOtherUrl }"
  />

  <Transition
    enter-active-class="transition-[opacity,transform] duration-300 ease-in delay-300"
    enter-from-class="opacity-0 translate-y-8"
  >
    <div
      v-if="seeOtherUrl && (!isCollapsible || isExpanded)"
      class="flex flex-col gap-8 md:flex-row md:items-center md:justify-between"
    >
      <p v-if="isValidSeeOtherUrl" class="body-1-bold pb-4 md:pb-0">
        {{ i18n(translations.notCompatible) }}
      </p>

      <!-- See other -->
      <RevButton
        v-if="isValidSeeOtherUrl"
        size="small"
        :to="seeOtherUrl"
        variant="primary"
      >
        {{ i18n(translations.seeOther) }}
      </RevButton>

      <!-- Mobile Show less -->
      <RevButton
        v-if="isCollapsible"
        ref="compatibleWithShowLessMobileButton"
        :aria-controls="LIST_ID_MOBILE"
        :aria-expanded="isExpanded"
        class="md:hidden"
        full-width="always"
        size="small"
        type="button"
        variant="secondary"
        @click="toggleExpanded"
      >
        {{ i18n(translations.showLess) }}
      </RevButton>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevDivider } from '@ds/components/Divider'

import { LIST_ID_DESKTOP, LIST_ID_MOBILE } from '../CompatibleWith.constants'
import translations from '../CompatibleWith.translations'

const i18n = useI18n()

const props = defineProps<{
  isCollapsible: boolean
  isExpanded: boolean
  hiddenProducts: string[]
  seeOtherUrl: string
}>()

const emit = defineEmits<{
  (e: 'toggle-expanded'): void
}>()

function toggleExpanded() {
  emit('toggle-expanded')
}

const isValidSeeOtherUrl = computed(() => {
  return props.seeOtherUrl.includes('l/apple-pencil')
})
</script>
